import {
	Typography
} from '@mui/material'
import { Box } from '@mui/system'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import TableViewBtn from './TableViewBtn'
import { handleCancelPending } from '../../../../../../helpers'
import { useDefaultComponentTools } from '../../../../../../hooks/useDefaultComponentTools'
import { setSelectedAsset } from '../../../../../../store/redusers/assets/actions'
import { selectAccessToken } from '../../../../../../store/redusers/auth/selectors'
import { setClosePendingAction } from '../../../../../../store/redusers/orders/actions'
import { setPositionIdInfo } from '../../../../../../store/redusers/positions/actions'
import {
	selectPendingCanceled,
	selectPositionAssetClass,
	selectPositionAssetId,
	selectPositionAssetName,
	selectPositionByID
} from '../../../../../../store/redusers/positions/selectors'
import { setEditOpenTrade } from '../../../../../../store/redusers/sidebar/actions'
import { selectUserId } from '../../../../../../store/redusers/user/selectors'
import AppButton from '../../../../../AppButton'
import AppIconDouble from '../../../../../AppIconDouble'
import AppPopup from '../../../../../AppPopup'


const TableCell = ({cell, index, positionId, currentTab}) => {
	const positionCellDataById = useSelector(selectPositionByID(currentTab, positionId, cell.id))
	const pendingCanceled = useSelector(selectPendingCanceled(currentTab, positionId))
	const positionAssetName = useSelector(selectPositionAssetName(currentTab, positionId))
	const positionAssetClass = useSelector(selectPositionAssetClass(currentTab, positionId))
	const positionAssetId = useSelector(selectPositionAssetId(currentTab, positionId))
	const {dispatch, alert, theme, t } = useDefaultComponentTools(true)
	const isButton = cell.button
	const isAssetName = cell.id === 'asset_name'
	const colors = (positionCellDataById < 0) ||
	(positionCellDataById?.toString().indexOf('Sell') >= 0) ?
		theme.palette.red : theme.palette.green
	const isType = cell.id === 'type' || cell.id === 'pnl'
	const isPendingInfo = pendingCanceled && cell.id === 'cancel'
	const isPendingCanceled = (pendingCanceled && cell.id === 'edit') || false
	const [isShowPopup, setIsShowPopup] = useState(false)
	const accessToken = useSelector(selectAccessToken)
	const isAuthorized = useSelector(selectUserId)
	const popupText = 'Are you sure. You want to remove pending order?'
	const isEditOpenTrade = cell.id === 'stop_loss' || cell.id === 'take_profit'
	const isEditPendingOrder = cell.id === 'edit'

	const handleClickAction = () => {
		if (currentTab === 'close' || pendingCanceled) {
			dispatch(setPositionIdInfo(
				{'positionId': positionId, 'positionType': currentTab},
				positionAssetName,
				'type_position_info'))
		}
		if (currentTab === 'pending' && !pendingCanceled && !isEditPendingOrder) setIsShowPopup(true)
		if (isEditOpenTrade){
			dispatch(setSelectedAsset({'assetSoId': positionAssetId, 'assetType': positionAssetClass}))
			dispatch(setEditOpenTrade(positionId, positionAssetName, 'type_open_trade'))
		}
		if (isEditPendingOrder){
			dispatch(setEditOpenTrade(positionId, positionAssetName, 'type_pending_trade'))
			dispatch(setSelectedAsset({'assetSoId': positionAssetId, 'assetType': positionAssetClass}))
		}
	}
	const currentAction = () => handleCancelPending(dispatch,
		setClosePendingAction({'tradeId': positionId}, accessToken, isAuthorized), alert, t)
	return (
		<Box
			align='right'
			sx={{
				m: '0 4px',
				minWidth: `calc(${cell.width} - 8px)`
			}}
		>
			<Box sx={{display: 'flex', justifyContent: index && 'center'}}>
				{!isAssetName ?
					null :
					<AppIconDouble
						name={positionCellDataById}
						double={positionAssetClass === 'currencies'}
						size={16}
						positionTop={'-1px'}
					/>
				}
				{(isButton && !pendingCanceled) || (pendingCanceled && isPendingInfo) ?
					(cell.id === 'view' ?
						<TableViewBtn positionId={positionId} currentTab={currentTab} /> :
						<AppButton
							inputSx={{'&:hover': {
								background: theme.palette.fourth,
								color: '#FFFFFF'
							}, background: theme.palette.second ,
							color: theme.palette.text.primary,
							fontSize: '12px', height: '32px',
							textTransform: 'capitalize', width: '100%'
							}}
							variant={''}
							disabled={false}
							onClick={handleClickAction}
							title={(pendingCanceled && isPendingInfo) ?
								t('Info') :
								(positionCellDataById || cell.label).toString()
							}
							type={''}
							uppercase={false}
						/>
					) : <Typography

						component='span'
						sx={{
							color: !isType ? theme.palette.text.primary : colors,
							ml: isAssetName ? 1 : 0,
							textAlign: 'center'
						}}
					>
						{isPendingCanceled ? 'Canceled' : (isType ? positionCellDataById : positionCellDataById)}
					</Typography>
				}
			</Box>
			{!isShowPopup ?
				null :
				<AppPopup
					onAction={currentAction}
					setOpenedComponent={setIsShowPopup}
					title={'Delete Pending Order'}
					text={popupText}
					actionTitle={'Remove'}
				/>
			}
		</Box>  
	)
}

TableCell.propTypes = {
	cell: PropTypes.object,
	currentTab: PropTypes.string,
	index: PropTypes.number,
	positionId: PropTypes.string
}


export default TableCell
